import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { CurrencyPricesVM } from '../../Structure/ViewModels/Admin/CurrencyPrices'

const CurrencyPrices = () => {
  const [vm, setVm] = useState<{viewModel:CurrencyPricesVM}>({viewModel:new CurrencyPricesVM()})
  const control = vm.viewModel
  useEffect(()=>{
    control.subscribeUpdate(setVm)
    control.getData()
  },[])

  return (
    <Container className='h-100'>
              {
          control.Show(
      <Row className='justify-content-center text-center'>
        <h3 className='p-3'>
          العملات
          <div className='d-flex justify-content-center'>
            <div className='d-flex p-2 fs-6 c-pointer'>
                <input type="checkbox"
                    id="active" checked={control.status=='active'}
                    onChange={a=>control.status=a.target.checked?'active':'inActive'} 
                />
                <label htmlFor="active" className='px-2 c-pointer'>النشطين</label>
            </div>
          </div>
        </h3>

        {
          control.Data?.filter(a=>a.status==control.status).map((item,index)=>(
            <Col key={index} xl={4} className='p-3'>
              <div className='py-1'>
                <input type="text" className='input-field' value={item.account}  onChange={a=>control.changeAccount(item.id,a.target.value)} />
              </div>
              <div className='py-1'>
                <input type="text" className='input-field' value={item.arabic_currency_name}  onChange={a=>control.changeArabicName(item.id,a.target.value)}/>
              </div>
              <div className='py-1'>
                <input type="text" className='input-field' value={item.english_currency_name}  onChange={a=>control.changeEnglishName(item.id,a.target.value)}/>
              </div>
              <div className='py-1'>
                <input type="text" className='input-field' value={item.price} onChange={a=>control.changePrice(item.id,a.target.value)}/>
              </div>
              <div className='py-1 d-flex justify-content-center'>
                <div className='p-1'>
                  <button className='button-II btn-cl-I px-3'  onClick={()=>control.sendNew(item)} >حفظ</button>
                </div>
                <div className='p-1'>
                  {
                    control.status==='active'?(
                      <button className='button-II btn-cl-I bg-danger px-3'  onClick={()=>control.changeState(item.id,'inActive')} >تعطيل</button>
                    ):(
                      <button className='button-II btn-cl-I bg-success px-3'  onClick={()=>control.changeState(item.id,'active')} >تفعيل</button>
                    )
                  }
                </div>
              </div>
            </Col>
          ))
        }
        {
          control.status=='active'?(
        <Col xl={4} className='p-3'>
          <div className='py-1'>
            <input type="text" className='input-field' value={control.NewData.account}  onChange={(a)=>control.Account=a.target.value} placeholder='اسم الحساب...'/>
          </div>
          <div className='py-1'>
            <input type="text" className='input-field' value={control.NewData.arabic_currency_name} onChange={(a)=>control.ArabicCurrencyName=a.target.value}  placeholder='اسم العملة...'/>
          </div>
          <div className='py-1'>
            <input type="text" className='input-field' value={control.NewData.english_currency_name} onChange={(a)=>control.EnglishCurrencyName=a.target.value}  placeholder='رمز العملة...'/>
          </div>
          <div className='py-1'>
            <input type="text" className='input-field' value={control.NewData.price} onChange={(a)=>control.Price=a.target.value} placeholder='سعر العملة...'/>
          </div>
          <div className='py-1'>
            <button className='button-II btn-cl-I' style={{width:'150px'}} onClick={()=>{control.sendNew(control.NewData);control.pushItem(control.NewData)}}>اضافة</button>
          </div>
        </Col>):null
        }
      </Row>)
        }
    </Container>
  )
}

export default CurrencyPrices
